import {on} from 'delegated-events'

on('click', '.js-toc-retry', function (event) {
  if (!(event.target instanceof Element)) return
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const menu = event.target.closest<HTMLElement>('.select-menu')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const loader = menu.querySelector<HTMLElement>('include-fragment')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const src = loader.getAttribute('src')!
  loader.setAttribute('src', '')
  loader.setAttribute('src', src)
})
